import { render, staticRenderFns } from "./SidebarStays.vue?vue&type=template&id=24d84004&scoped=true&"
import script from "./SidebarStays.vue?vue&type=script&lang=ts&"
export * from "./SidebarStays.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarStays.vue?vue&type=style&index=0&id=24d84004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d84004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d84004')) {
      api.createRecord('24d84004', component.options)
    } else {
      api.reload('24d84004', component.options)
    }
    module.hot.accept("./SidebarStays.vue?vue&type=template&id=24d84004&scoped=true&", function () {
      api.rerender('24d84004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/SidebarStays.vue"
export default component.exports